<template>
    <div class="individual-list__options">
        <label
            class="individual-list__options-checkbox"
            v-if="products.length > 0"
        >
            <input
                type="checkbox"
                name="allList"
                @click="isCheckAllFun()"
                v-model="cbSelectAll"
                value="1"
            />
            <span>Select All</span>
        </label>

        <div
            class="individual-list__options-wrap"
            v-if="
                checkedProduct.length !== 0 &&
                    products.length > 0 &&
                    all.length > 0
            "
        >
            <span class="individual-list__options-move" @click="openmove()"
                ><SvgIcon
                    class="individual-list__options-icon"
                    iconName="ico-reply-solid"
                />Move Items</span
            >
            <div
                v-if="moveItem && all.length > 0"
                v-on-click-outside="closePopup"
                class="product-info-box__add-lists"
            >
                <div
                    class="product-info-box__add-list-predefined"
                    v-for="item in all"
                    :key="item.ID"
                >
                    <label
                        class="product-info-box__add-list-predefined-checkbox"
                    >
                        <input
                            type="radio"
                            name="compare"
                            @click="moveitems(item.ID)"
                        />
                        <span v-html="item.title"></span>
                    </label>
                    <a
                        class="product-info-box__add-list-predefined-cta-btn"
                        :href="
                            kadraGlobal.Url + '/single-my-lists?id=' + item.ID
                        "
                        >View List</a
                    >
                </div>
            </div>
        </div>
        <div
            class="individual-list__options-wrap"
            v-if="checkedProduct.length !== 0 && products.length > 0"
        >
            <span
                class="individual-list__options-delete"
                @click="deleteItems()"
            >
                <SvgIcon
                    class="individual-list__options-icon"
                    iconName="ico-trash"
                />Delete Items</span
            >
        </div>
        <div
            class="individual-list__options-wrap"
            v-if="checkedProduct.length !== 0 && products.length > 0"
        >
            <span
                class="individual-list__options-addtocart"
                @click="addToCartItems()"
            >
                <SvgIcon
                    class="individual-list__options-icon"
                    iconName="ico-cart"
                />Add To Cart</span
            >
        </div>
    </div>
</template>

<script>
import SvgIcon from '../../../base/SvgIcon/SvgIcon.vue';
import { mixin as onClickOutside } from 'vue-on-click-outside';

export default {
    props: ['isCheckAll', 'all', 'products', 'checkedProduct', 'wishlist'],
    mixins: [onClickOutside],
    data() {
        return {
            moveItem: false,
            kadraGlobal: kadraGlobal,
            cbSelectAll: null
        };
    },
    components: {
        SvgIcon
    },
    mounted() {
        document.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
                this.closePopup();
            }
        });
    },
    methods: {
        isCheckAllFun() {
            this.$emit('isCheckAllFun');
        },
        deleteItems() {
            this.$emit('deleteItems');
            this.cbSelectAll = false;
        },
        addToCartItems() {
            this.$emit('addToCartItems');
            this.cbSelectAll = false;
        },
        moveitems(wishId) {
            if (this.checkedProduct.length !== 0) {
                this.$store.dispatch('moveItem', {
                    arr: this.checkedProduct,
                    wish_id: wishId,
                    curentId: this.wishlist.ID
                });
                this.moveItem = false;
                this.$emit('unselectProduct');
            }
        },
        openmove() {
            if (this.checkedProduct.length !== 0) {
                this.moveItem = !this.moveItem;
            } else {
                this.moveItem = false;
            }
        },
        closePopup() {
            this.moveItem = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.product-info-box__add-lists {
    position: absolute;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    width: 289px;
    max-height: 160px;
    padding: 19px;
    border-radius: 5px;
    box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
    background: #fff;
    z-index: 2;
    overflow-y: auto;

    @include mq(460px) {
        left: 0;
        transform: translateX(0);
    }
}

.individual-list__options-wrap {
    position: relative;
}
</style>
